module.exports = __webpack_public_path__ + "images/bc6c53c9.pay_1_chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_1_chs.png
// module id = 468
// module chunks = 0